// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessMessage_root__90SNj"};